import {useZero} from '@/shared/integrations/zero/use-zero'
import {UpdateResourceStatusSchema} from '@cypro/engine/mutators/util'
import {useCallback} from 'react'

export function useUpdateDrugsCategoryStatus() {
  const zero = useZero()

  return useCallback(
    (payload: UpdateResourceStatusSchema) =>
      zero.attemptMutation(
        zero.mutators.drugsCategories.updateStatus(payload),
        async mutation => await mutation.server
      ),
    [zero]
  )
}
